import {
  LayoutDashboard,
  Bot,
  Settings,
  Sparkles,
  Globe,
  Gauge,
  List,
  Package,
  Database,
  BarChart3,
  FileText,
  Users,
  Workflow,
  Wallet,
  Bell,
  Brain,
  Boxes,
  Plug,
  Shield,
  Search,
  MessageSquare,
  Calendar,
  Map,
  Mic,
  Briefcase,
  HardDrive,
  type LucideIcon,
} from 'lucide-react';

const PATH_ICONS: Record<string, LucideIcon> = {
  '/dashboard': LayoutDashboard,
  '/clu': Bot,
  '/settings': Settings,
  '/galaxia': Sparkles,
  '/clerks-ecosystem': Globe,
  '/control-center': Gauge,
  '/menu': List,
  '/billing': Wallet,
  '/profile': Users,
  '/drive': HardDrive,
};

const EMOJI_ICONS: Record<string, LucideIcon> = {
  '🤖': Bot,
  '⚙️': Settings,
  '📊': BarChart3,
  '📋': List,
  '🌐': Globe,
  '🌌': Sparkles,
  '🕹️': Gauge,
  '📦': Package,
  '🗄️': Database,
  '📄': FileText,
  '👥': Users,
  '🔔': Bell,
  '🧠': Brain,
  '🔌': Plug,
  '🛡️': Shield,
  '🔍': Search,
  '💬': MessageSquare,
  '📅': Calendar,
  '🗺️': Map,
  '🎙️': Mic,
  '💼': Briefcase,
  '🧩': Boxes,
  '⚡': Workflow,
  '💾': HardDrive,
};

export function resolveNavIcon(path: string, emoji?: string): LucideIcon {
  const basePath = '/' + (path || '').split('?')[0].split('/').filter(Boolean)[0];
  if (PATH_ICONS[basePath]) return PATH_ICONS[basePath];
  if (emoji && EMOJI_ICONS[emoji]) return EMOJI_ICONS[emoji];
  return Package;
}
